import omitBy from 'lodash/omitBy';
import mapObject from 'lodash/mapValues';

export const nullifyUndefinedProperties = (obj) =>
    mapObject(obj, (value) => (typeof value === 'undefined' ? null : value));

export const removePropertiesWithoutValue = (obj) =>
    omitBy(obj, (value) => value === null || value === undefined);
